import { useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { KeyRound, ShieldCheck } from "lucide-react";

export const AccountSettings = () => {
  const { user } = useAuth();
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [saving, setSaving] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.current || !form.next) {
      toast.error("Mohon isi semua kolom.");
      return;
    }
    if (form.next.length < 8) {
      toast.error("Kata sandi baru minimal 8 karakter.");
      return;
    }
    if (form.next !== form.confirm) {
      toast.error("Konfirmasi kata sandi tidak sama.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { current_password: form.current, new_password: form.next });
      toast.success("Kata sandi berhasil diubah. Gunakan kata sandi baru saat login berikutnya.");
      setForm({ current: "", next: "", confirm: "" });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="max-w-md" data-testid="account-settings-panel">
      <div className="bg-white border border-slate-200 rounded-xl p-7">
        <div className="flex items-center gap-3 mb-1">
          <div className="w-10 h-10 rounded-xl bg-orange-50 text-orange-600 flex items-center justify-center">
            <KeyRound size={20} />
          </div>
          <div>
            <h3 className="font-heading font-bold text-slate-900">Ganti Kata Sandi</h3>
            <p className="font-mono text-xs text-slate-400">{user?.email}</p>
          </div>
        </div>
        <form onSubmit={submit} className="mt-6 space-y-4" data-testid="change-password-form">
          <div className="space-y-1.5">
            <Label htmlFor="cur">Kata Sandi Saat Ini</Label>
            <Input id="cur" type="password" value={form.current} onChange={(e) => setForm({ ...form, current: e.target.value })} data-testid="current-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="new">Kata Sandi Baru (min. 8 karakter)</Label>
            <Input id="new" type="password" value={form.next} onChange={(e) => setForm({ ...form, next: e.target.value })} data-testid="new-password-input" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="conf">Ulangi Kata Sandi Baru</Label>
            <Input id="conf" type="password" value={form.confirm} onChange={(e) => setForm({ ...form, confirm: e.target.value })} data-testid="confirm-password-input" />
          </div>
          <Button type="submit" disabled={saving} className="btn-pop w-full bg-orange-600 hover:bg-orange-500 rounded-full font-bold" data-testid="change-password-btn">
            {saving ? "Menyimpan..." : "Ubah Kata Sandi"}
          </Button>
        </form>
        <p className="flex gap-2 text-xs text-slate-400 mt-5">
          <ShieldCheck size={14} className="shrink-0 mt-0.5 text-emerald-500" />
          Disarankan mengganti kata sandi secara berkala dan tidak membagikannya kepada pihak lain.
        </p>
      </div>
    </div>
  );
};
